export class AudienceCampaign {
    constructor() {
        this.ProjectId = 0;
        this.Name = '';
        this.Details = '';
        this.CreatedOn = new Date();
        this.ModifiedOn = new Date();
        this.Schedule = '';
        this.Status = '';
    }
}
//# sourceMappingURL=AudienceCampaign.js.map